



































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { vipIsTryForFree, boughtVip } from "@/utils/general_utils";
@Component({
  components: {}
})
export default class VipButton extends Vue {
  @Prop({ default: false })
  private shake?: boolean;
  @Prop({ default: true })
  private noTextScroll?: boolean;
  @Prop({ default: false })
  private small?: boolean;
  @Prop()
  private offer: any;

  get hasBoughtVip() {
    return boughtVip();
  }

  get isShowContinue() {
    return this.offer && this.offer.effect > 1;
  }

  get isShowTryForFree() {
    return vipIsTryForFree(this.offer);
  }

  private buyVip() {
    this.$emit("clickVipButton");
  }
}
